// extracted by mini-css-extract-plugin
export default {"Block":"InfoBlock-module__Block__LBzei","Content":"InfoBlock-module__Content__AzLo1","Footer":"InfoBlock-module__Footer__DpgiT"};